import { Component, computed, input, output } from '@angular/core';
import { PlaylistCardShort } from '@app/app/shared/models';

const CARD_GRADIENTS = [
  'linear-gradient(135deg, #e8d5f5, #c5b3e8)',
  'linear-gradient(135deg, #d5e8f5, #b3c5e8)',
  'linear-gradient(135deg, #c5e8d5, #8dd5b0)',
  'linear-gradient(135deg, #d5f5e8, #8de8c5)',
  'linear-gradient(135deg, #d5d5f5, #b3b3e8)',
  'linear-gradient(135deg, #f5e8d5, #e8d5a0)',
];

@Component({
  selector: 'ptl-card-item-list-view',
  templateUrl: './card-item-list-view.component.html',
  styleUrls: ['./card-item-list-view.component.scss'],
})
export class CardItemListViewComponent {
  card = input<PlaylistCardShort>();
  cardIndex = input(0);

  cardClick = output<PlaylistCardShort>();

  gradient = computed(() => CARD_GRADIENTS[this.cardIndex() % CARD_GRADIENTS.length]);

  typeDisplayName = computed(() => {
    const type = this.card()?.v3CardType || this.card()?.collectionType;
    if (!type) return '';
    return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
  });

  typeColorClass = computed(() => {
    const type = this.card()?.v3CardType || this.card()?.collectionType;
    if (!type) return '';
    const t = type.toUpperCase();
    if (t === 'COURSE' || t === 'STANDARD') return 'type-course';
    if (t === 'EVENT') return 'type-event';
    if (t === 'MODULE' || t === 'PROGRAM') return 'type-module';
    return 'type-default';
  });

  readonly RING_RADIUS = 21;
  readonly RING_CIRCUMFERENCE = 2 * Math.PI * this.RING_RADIUS;

  progress = computed(() => {
    const card = this.card();
    const completed = card?.completedItemsCount ?? 0;
    const total = card?.totalItemsCount ?? 0;
    return total > 0 ? Math.round((completed / total) * 100) : 0;
  });

  progressArc = computed(() => {
    const arc = (this.progress() / 100) * this.RING_CIRCUMFERENCE;
    const gap = this.RING_CIRCUMFERENCE - arc;
    return `${arc} ${gap}`;
  });

  onCardClick(): void {
    const card = this.card();
    if (card?.lmsCourseUrl) {
      window.open(card.lmsCourseUrl, '_blank', 'noopener,noreferrer');
    }
    this.cardClick.emit(card);
  }
}
